module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Rechercher un client ou prospect",
      "visible": _vm.visible,
      "close-on-click-modal": false,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('customer-search-form', {
    attrs: {
      "values": _vm.form
    },
    on: {
      "loading": _vm.handleLoading,
      "loaded": _vm.handleLoaded
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.paginatedCustomers,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Nom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('customer', {
          attrs: {
            "item": scope.row
          },
          nativeOn: {
            "click": function($event) {
              return _vm.close()
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Suivi commercial"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.loadingReminders) ? _c('div', [_c('pulse-loader', {
          attrs: {
            "color": "#cccccc",
            "size": "8px"
          }
        })], 1) : _c('div', [(_vm.models.reminders.find(function (reminder) { return reminder.customer_id === scope.row.id; })) ? _c('div', [_c('reminder', {
          attrs: {
            "item": _vm.models.reminders.find(function (reminder) { return reminder.customer_id === scope.row.id; })
          }
        }), _vm._v("\n            ("), _c('user', {
          attrs: {
            "item": _vm.users.find(function (user) { return user.id === _vm.models.reminders.find(function (reminder) { return reminder.customer_id === scope.row.id; }).user_id; })
          }
        }), _vm._v(")\n          ")], 1) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "text-muted font-13"
        }, [_c('strong', [_vm._v("Dans le parc de ")]), _vm._v(" :\n          "), (scope.row.user_id) ? _c('span', [_c('user', {
          attrs: {
            "item": _vm.users.find(function (user) { return user.id === scope.row.user_id; })
          }
        })], 1) : _c('span', [_vm._v("Aucun")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Contacts"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('customer', {
          attrs: {
            "present": "contacts",
            "item": scope.row
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Services"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('customer', {
          attrs: {
            "present": "services",
            "item": scope.row
          }
        })]
      }
    }])
  }), _vm._v(" "), (_vm.merge) ? _c('el-table-column', {
    attrs: {
      "label": "Fusionner avec"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.merge.id === scope.row.id) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning",
            "disabled": ""
          }
        }, [_vm._v("Même fiche")])], 1) : (Object.keys(_vm.merge.sources).filter(function (n) { return Object.keys(scope.row.sources).includes(n); }).length > 0) ? _c('div', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning",
            "disabled": ""
          }
        }, [_vm._v("Même interface")])], 1) : _c('div', [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.openMerge(scope.row, _vm.merge)
            }
          },
          nativeOn: {
            "click": function($event) {
              return _vm.close()
            }
          }
        }, [_vm._v("Fusionner")])], 1)]
      }
    }], null, false, 1680691950)
  }) : _vm._e()], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.page.number,
      "page-size": _vm.page.size,
      "layout": "total, prev, pager, next",
      "total": _vm.customers.length
    },
    on: {
      "update:currentPage": function($event) {
        return _vm.$set(_vm.page, "number", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.page, "number", $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19b69884"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Modals/SearchCustomerModal.vue
// module id = 667
// module chunks = 1